module.exports = __webpack_public_path__ + "2a8b998b727b1364104c61edb54e6f02.png";